import React from 'react';

export const SmallCloseIcon = () => (
  <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 1.33862L8.82268 9.66145M0.500068 9.66145L8.82268 1.33862" stroke="#FF0000" strokeLinecap="round"/>
  </svg>
);
